export default __webpack_public_path__ + "partner_10118917.png";